import { ChevronRightIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnCard } from "@/components/VnCard";
import { VnIcon } from "@/components/VnIcon";
import { VnLink } from "@/components/VnLink";
import { VnText } from "@/components/VnText/VnText";
import { getApplicationTypeColor } from "@/utils/applications";
import { cn } from "@/utils/tailwind";

/**
 * Persistent "Renewals" section. Shows a single grouped link into the Medicaid
 * renewals list. Visibility is gated by the caller (only when the household has
 * a renewal past NOT_STARTED).
 */
const RedeterminationsSection = () => (
  <VnBox className="gap-6">
    <VnText variant="headerTwo" i18nKey="native:redeterminations.title" />

    <VnLink href={{ pathname: "/(authed)/renewals/medicaid" }} asChild>
      <VnCard className="relative flex flex-row items-center justify-between overflow-hidden">
        <VnBox
          className={cn(
            "absolute left-0 size-3 h-full",
            getApplicationTypeColor("MEDICAID"),
          )}
        />
        <VnText
          variant="lgMedium"
          className="ml-2"
          i18nKey="native:redeterminations.medicaidRenewals"
        />
        <VnIcon as={ChevronRightIcon} />
      </VnCard>
    </VnLink>
  </VnBox>
);

export { RedeterminationsSection };
